module.exports = __webpack_public_path__ + "img/CM-BS-24-CJDR-Modern.c487bba9.jpg";